export default [
  {
    name: "Websites Development",
    image: require("../assets/img/icons/website-development.png"),
  },
  {
    name: "Systems Integrations",
    image: require("../assets/img/icons/systems-integrations.png"),
  },
  {
    name: "Graphic Designing",
    image: require("../assets/img/icons/graphic-designing.png"),
  },
  {
    name: "Virtual Private Servers Hosting",
    image: require("../assets/img/icons/virtual-private-servers-hosting.png"),
  },
  {
    name: "Mobile Applications Development",
    image: require("../assets/img/icons/mobile-application-development.png"),
  },
  {
    name: "Desktop Applications Developments",
    image: require("../assets/img/icons/desktop-applications-development.png"),
  },
  {
    name: "Email Hosting",
    image: require("../assets/img/icons/email-hosting.png"),
  },
  {
    name: "Web Hosting",
    image: require("../assets/img/icons/web-hosting.png"),
  },
  {
    name: "Online Payments Integrations",
    image: require("../assets/img/icons/online-payments-integrations.png"),
  },
  {
    name: "Digital Transformation Consultancy",
    image: require("../assets/img/icons/digital-transformation-consultancy.png"),
  },
  {
    name: "Project Management Consultancy",
    image: require("../assets/img/icons/computer-accessories-and-supply.png"),
  },
  {
    name: "Systems Security implementations",
    image: require("../assets/img/icons/systems-integrations.png"),
  },
  {
    name: "Hardware integrations",
    image: require("../assets/img/icons/hardware-integrations.png"),
  },
  {
    name: "Bulk SMS Services",
    image: require("../assets/img/icons/bulk-SMS-services.png"),
  },
  {
    name: "Bulk Emails Services",
    image: require("../assets/img/icons/bulk-emails-services.png"),
  },
];
